import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {deprecatedTrackEvent} from 'analytics/Analytics';
import {INSIGHTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {useDraftQueryContext} from 'insights/analytics-queries/block-editor/AnalyticsBlockEditor';
import WarehouseDiagramModal, {
  WarehouseDiagramModalProps,
} from 'insights/warehouse/warehouse-diagram/WarehouseDiagramModal';
import HoverIcon from 'nav/expanded/HoverIcon';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import runModal from 'ui-library/runModal';

export interface OpenEntityDiagramButtonProps {
  schemaName: string;
  tableName: string;
  useHoverIcon: boolean;
  tooltipPlacement: TooltipPlacement;
}

function OpenEntityDiagramButton(props: OpenEntityDiagramButtonProps): JSX.Element {
  const {draftSQLQuery, setDraftSQLQuery} = useDraftQueryContext();

  function openEntityDiagramModal(): void {
    deprecatedTrackEvent(INSIGHTS_ANALYTICS_ACTIONS.OPENED_WAREHOUSE_DIAGRAM, {
      schemaName: props.schemaName,
      tableName: props.tableName,
    });

    const modalProps: WarehouseDiagramModalProps = {
      schemaName: props.schemaName,
      focusTableName: props.tableName,
      draftSQLQuery,
      setDraftSQLQuery,
      onRequestClose: () => {},
    };
    runModal(WarehouseDiagramModal, modalProps);
  }

  const sharedProps: {icon: BenchlingIconName; onClick: () => void} = {
    icon: 'erd',
    onClick: openEntityDiagramModal,
  };

  return (
    <Tooltip title="Open entity diagram" placement={props.tooltipPlacement}>
      {props.useHoverIcon ? (
        <HoverIcon {...sharedProps} className={css(styles.erdHoverIcon)} />
      ) : (
        <Button {...sharedProps} buttonStyle={ButtonStyle.TERTIARY_GRAY} size={ButtonSize.MINI} />
      )}
    </Tooltip>
  );
}
OpenEntityDiagramButton.defaultProps = {
  useHoverIcon: false,
};

// Memoize largely as a preventative measure because tooltips can sometimes be expensive to render
export default React.memo(OpenEntityDiagramButton);

const styles = StyleSheet.create({
  erdHoverIcon: {
    marginLeft: 4,
  },
});
